






















import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { nxExtenManageClient } from "@/api/nxExtenManageClient";
import { NxteleListReq } from "@/pbjs/xcommon/nxExtenManage_pb";
import { setCommon, setPage } from "@/utils/request";
import { setMetaData } from "@/utils";

@Component({
  name: "RoleList"
})
export default class RoleList extends Vue {
  @Prop() NxteleId!: any; 
  @Prop() isdisabled!:any
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private nxteleValue: string = "";
  @Provide() private nxteleOptions: any = [];
  @Provide() private token: any = "";
  private created() {
    this.token = localStorage.getItem("token");
    this.nxteleList();
   
  }
  private mounted(): void {
    this.resetRole();
  }


  //  lee 获取Nxtele列表
  private nxteleList() {
    let request: any = new NxteleListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    // lee 列表不傳
    // request.setName();
    // request.setAppkey();
    // request.setSecretkey();
    nxExtenManageClient.nxteleList(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            if (data.nxtelelistList) {
              this.nxteleOptions = data.nxtelelistList;
               if (this.NxteleId!=='') {
                 this.nxteleOptions.map((item:any)=>{
                   if (this.NxteleId==item.id) {
                     this.nxteleValue=item.name
                   }
                 }) 
               }
            }
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          if (err.code == 16) {
            this.$router.push("./login");
          }
        }
      }
    );
  }
  //  lee 重置角色
  private resetRole() {
    this.$store.commit("SET_NXTELE", {
      id: 0,
      name: "",
      appkey: "",
      ctime: "",
      utime: ""
    });
  }
  //  lee 选择角色
  private selectRole(val: any) {
    if (this.nxteleOptions) {
      let _role: any = "";
      _role = val ? this.nxteleOptions.find((item: any) => { return val == item.name;}) : "";
      this.$store.dispatch("storeNxtele", _role);
      this.$emit('NxteleIdChange',_role)
    }
  }
}
